module.exports = __webpack_public_path__ + "img/sicherungsfach_8.4d9aec86.png";